export default __webpack_public_path__ + "../images/tutorials/corral/image1d.png";